import { render, staticRenderFns } from "./x-video-hls.vue?vue&type=template&id=0dd1d612&scoped=true"
import script from "./x-video-hls.vue?vue&type=script&lang=js"
export * from "./x-video-hls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd1d612",
  null
  
)

export default component.exports